<template>
  <div class="EditAddEquipamento">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-card shadow="never">
        <el-row :gutter="20">
          <el-col :lg="12" :sm="12" :xs="24">
            <el-form-item prop="marketplace_id" label="Marketplace" :error="error.marketplace_id">
              <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="isEditMkt" @handleValue="(x) => {ruleForm.marketplace_id = x}" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24">
            <el-form-item prop="provider_id" label="Provider" :error="error.provider_id">
              <SearchProviders :model="ruleForm.provider_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.provider_id = x}" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="12" :sm="12" :xs="24">
            <el-form-item prop="equipment_model_id" label="Modelo de Equipamentos" :error="error.equipment_model_id">
              <SelectSearchModeloEquipamento :model="ruleForm.equipment_model_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.equipment_model_id = x}" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24">
            <el-form-item prop="status" label="Status" :error="error.status">
              <el-select v-model="ruleForm.status" clearable style="width: 100%">
                <el-option :label="'Ativo'" :value="'active'" />
                <el-option :label="'Inativo'" :value="'inactive'" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="serial_number" label="Nº Serial" :error="error.serial_number">
          <el-input size="large" v-model="ruleForm.serial_number"></el-input>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import {
  deleteEquipamentos,
  getEquipamentos,
  postEquipamentos,
  putEquipamentos
} from "@/app/domains/Records/services";
import {clearRuleForm, makeErrorFilds, setFormData} from "@/app/plugins/utils";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import SelectSearchModeloEquipamento from "@/app/components/ModeloEquipamento/SelectSearchModeloEquipamento";
import {mapGetters} from "vuex";

export default {
  name: "EditAddEquipamento",
  components: {
    HeaderPage,
    SelectSearchMarketplace,
    SearchProviders,
    SelectSearchModeloEquipamento,
  },
  data () {
    return {
      loadingPage: false,
      isPass: true,
      error: {},
      ruleForm: {
        status: 'active',
      },
      rules: {
        // marketplace_id: [
        //   {required: true, message: 'Requerido', trigger: 'blur'}
        // ],
        // password: [
        //   { validator: validatePass, trigger: 'blur' }
        //   // { required: true, message: 'Informe um senha.', trigger: 'blur' },
        //   // { min: 8, max: 999, message: 'Minimo de 8 Caracteres.', trigger: 'blur' }
        // ],
        // type_account_id: [
        //   {required: true, message: 'Selecione um tipo de conta.', trigger: 'blur'}
        // ],
        // marketplace_id: [
        //   {required: true, message: 'Selecione um Marketplace.', trigger: 'blur'}
        // ],
        // department_store_id: [
        //   {required: true, message: 'Selecione um Estabelecimento Comercial.', trigger: 'blur'}
        // ],
        // agent_id: [
        //   {required: true, message: 'Selecione um Representante.', trigger: 'blur'}
        // ],
      },
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          this.error = {}
          try {
            if (this.ruleForm.id) {
              //Editando
              await putEquipamentos(this.ruleForm)
              this.$message({
                showClose: true,
                message: 'Registro foi editado com sucesso.',
                type: 'success'
              })
              await this.$router.push({name: 'records.equipment.index'})
            } else {
              // Adicionando
              await postEquipamentos(setFormData(this.ruleForm))
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
              await this.$router.push({name: 'records.equipment.index'})
            }
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    async handleAction (act) {
      if (act === 'DELETE') {
        this.loadingPage = true
        this.$confirm('Deseja realmente deletar este equipamento?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          center: true,
          type: 'warning'
        }).then(async () => {
          this.error = {}
          try {
            await deleteEquipamentos(this.ruleForm.id)
            await this.$router.push({name: 'records.equipment.index'})
            this.$message({
              showClose: true,
              message: 'Equipamento foi deletado.',
              type: 'success'
            })
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {
          this.loadingPage = false
        });
      }
    },
  },
  computed: {
    isEditMkt: function () {
      if (this.$can('2|4|5')) {
        return true
      } else {
        return !!(this.ruleForm.id)
      }
    },
    isEdit: function () {
      return !!(this.ruleForm.id)
    },
    ...mapGetters('Auth', ['currentUser'])
  },
  async beforeMount() {
    this.loadingPage = true
    try {
      if (this.$route.params.id) {
        let response = await getEquipamentos(`/${this.$route.params.id}`)
        this.ruleForm = clearRuleForm(response.data)
      } else {
        this.isEditEC = true
        if (this.$can('2|4|5')) {
          this.ruleForm.marketplace_id = this.currentUser.marketplace_id
        }
        if (this.$can('4')) {
          this.ruleForm.agent_id = this.currentUser.agent_id
        }
        if (this.$can('5')) {
          this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
          this.ruleForm.department_store_id = this.currentUser.department_store_id

          this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
          this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id

          this.$set(this.ruleForm, 'agent_id', this.currentUser.department_store.agent_id)
          this.ruleForm.agent_id = this.currentUser.department_store.agent_id
        }
      }
    } catch (e) {
      await this.$router.push({name: 'records.equipment.index'})
      this.$message({
        showClose: true,
        message: 'Erro ao Carregar dados',
        type: 'error'
      })
    } finally {
      this.loadingPage = false
    }
  }
}
</script>

<style scoped>

</style>
